/**
 * Utility for generating unique IDs based on timestamp and random values
 * Similar entropy to UUID v6 but without external dependencies
 */

/**
 * Generates a unique ID based on current Unix timestamp and random values
 * Format: <timestamp>-<random>
 * @returns A unique string ID
 */
export function generateId(): string {
  const timestamp = Date.now()
  const randomPart = Math.random().toString(36).substring(2, 10) // 8 characters of randomness
  return `${timestamp}-${randomPart}`
}
